import { render, staticRenderFns } from "./Poster.vue?vue&type=template&id=4c98ed48&"
import script from "./Poster.vue?vue&type=script&lang=js&"
export * from "./Poster.vue?vue&type=script&lang=js&"
import style0 from "./Poster.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports